// extracted by mini-css-extract-plugin
export default {"form":"StudentNotesComposeForm_form__Elwii","actions":"StudentNotesComposeForm_actions__tY-x+","actionButton":"StudentNotesComposeForm_actionButton__RiGLX"};